import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, CardHeader } from 'reactstrap';
// import DataTable from 'react-data-table-component';
import { H3 } from '../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router';
import { getMasterDataToken } from '../../../Utils/restUtils';
import { getCompanySubscription } from '../../../CommonURL';
import { Subscription } from '../../../Constant';
import { SubscriptionCompanyColumns } from '../../../Data/MockTable/TempData';

const SubTabs = ({ subscription, loading }) => {
    
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const navigate = useNavigate();
    const handlePageChange = page => {
        fetchCustomer(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomer(page, newPerPage);
        setPerPage(newPerPage);
    };

    return (
        <Col sm="12" xl="6 xl-100">
            <Card>
                <CardHeader>
                    <H3 attrH3={{ style: { paddingLeft: '10px' } }}>{Subscription}</H3>
                </CardHeader>
                <CardBody>
                    <div className="order-history table-responsive" style={{ marginTop: '-35px', height: '220px' }}>
                        <DataTable
                            data={subscription}
                            columns={SubscriptionCompanyColumns}
                            pagination
                            progressPending={loading}
                            paginationServer
                            defaultSortAsc
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default SubTabs;
